export const filterMountingMaterialColor = () => [
    {
        name: '1',
        original: 'nur grundiert',
        value: ''
    },
    {
        name: '2',
        original: '',
        value: ''
    },
    {
        name: 'RAL 1000',
        original: 'RAL 1000 Grünbeige',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1001',
        original: 'RAL 1001 Beige',
        value: 'LLT130001'
    },
    {
        name: 'RAL 1002',
        original: 'RAL 1002 Sandgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1003',
        original: 'RAL 1003 Signalgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1004',
        original: 'RAL 1004 Goldgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1005',
        original: 'RAL 1005 Honiggelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1006',
        original: 'RAL 1006 Maisgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1007',
        original: 'RAL 1007 Chromgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1011',
        original: 'RAL 1011 Braunbeige',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1012',
        original: 'RAL 1012 Zitronengelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1013',
        original: 'RAL 1013 Perlweiß',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1014',
        original: 'RAL 1014 Elfenbein',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1015',
        original: 'RAL 1015 Hellelfenbein',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1016',
        original: 'RAL 1016 Schwefelgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1017',
        original: 'RAL 1017 Safrangelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1018',
        original: 'RAL 1018 Zinkgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1019',
        original: 'RAL 1019 Graubeige',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1020',
        original: 'RAL 1020 Olivgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1021',
        original: 'RAL 1021 Kadmiumgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1023',
        original: 'RAL 1023 Verkehrsgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1024',
        original: 'RAL 1024 Ockergelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1027',
        original: 'RAL 1027 Currygelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1028',
        original: 'RAL 1028 Melonengelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1032',
        original: 'RAL 1032 Ginstergelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1033',
        original: 'RAL 1033 Dahliengelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 1034',
        original: 'RAL 1034 Pastellgelb',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2000',
        original: 'RAL 2000 Gelborange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2001',
        original: 'RAL 2001 Rotorange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2002',
        original: 'RAL 2002 Blutorange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2003',
        original: 'RAL 2003 Pastellorange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2004',
        original: 'RAL 2004 Reinorange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2008',
        original: 'RAL 2008 Hellrotorange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2009',
        original: 'RAL 2009 Verkehrsorange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2010',
        original: 'RAL 2010 Signalorange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2011',
        original: 'RAL 2011 Tieforange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 2012',
        original: 'RAL 2012 Lachsorange',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3000',
        original: 'RAL 3000 Feuerrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3001',
        original: 'RAL 3001 Signalrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3002',
        original: 'RAL 3002 Karminrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3003',
        original: 'RAL 3003 Rubinrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3004',
        original: 'RAL 3004 Purpurrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3005',
        original: 'RAL 3005 Weinrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3007',
        original: 'RAL 3007 Schwarzrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3009',
        original: 'RAL 3009 Oxidrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3011',
        original: 'RAL 3011 Braunrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3012',
        original: 'RAL 3012 Beigerot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3013',
        original: 'RAL 3013 Tomatenrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3014',
        original: 'RAL 3014 Altrosa',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3015',
        original: 'RAL 3015 Hellrosa',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3016',
        original: 'RAL 3016 Korallenrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3017',
        original: 'RAL 3017 Rosé',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3018',
        original: 'RAL 3018 Erdbeerrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3020',
        original: 'RAL 3020 Verkehrsrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3022',
        original: 'RAL 3022 Lachsrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3027',
        original: 'RAL 3027 Himbeerot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 3031',
        original: 'RAL 3031 Orientrot',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4001',
        original: 'RAL 4001 Rotlila',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4002',
        original: 'RAL 4002 Rotviolett',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4003',
        original: 'RAL 4003 Erikaviolett',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4004',
        original: 'RAL 4004 Bordeauxviolett',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4005',
        original: 'RAL 4005 Blaulila',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4006',
        original: 'RAL 4006 Verkehrspurpur',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4007',
        original: 'RAL 4007 Purpurviolett',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4008',
        original: 'RAL 4008 Signalviolett',
        value: 'LLT130011'
    },
    {
        name: 'RAL 4009',
        original: 'RAL 4009 Pastellviolett',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5000',
        original: 'RAL 5000 Violettblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5001',
        original: 'RAL 5001 Grünblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5002',
        original: 'RAL 5002 Ultramarineblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5003',
        original: 'RAL 5003 Saphirblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5004',
        original: 'RAL 5004 Schwarzblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5005',
        original: 'RAL 5005 Signalblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5007',
        original: 'RAL 5007 Brillantblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5008',
        original: 'RAL 5008 Graublau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5009',
        original: 'RAL 5009 Azurblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5010',
        original: 'RAL 5010 Enzianblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5011',
        original: 'RAL 5011 Stahlblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5012',
        original: 'RAL 5012 Lichtblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5013',
        original: 'RAL 5013 Kobaltblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5014',
        original: 'RAL 5014 Taubenblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5015',
        original: 'RAL 5015 Himmelblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5017',
        original: 'RAL 5017 Verkehrsblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5018',
        original: 'RAL 5018 Türkisblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5019',
        original: 'RAL 5019 Capriblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5020',
        original: 'RAL 5020 Ozeanblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5021',
        original: 'RAL 5021 Wasserblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5022',
        original: 'RAL 5022 Nachtblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5023',
        original: 'RAL 5023 Fernblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 5024',
        original: 'RAL 5024 Pastellblau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6000',
        original: 'RAL 6000 Patinagrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6001',
        original: 'RAL 6001 Smaragdgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6002',
        original: 'RAL 6002 Laubgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6003',
        original: 'RAL 6003 Olivgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6004',
        original: 'RAL 6004 Blaugrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6005',
        original: 'RAL 6005 Moosgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6006',
        original: 'RAL 6006 Grauoliv',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6007',
        original: 'RAL 6007 Flaschengrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6008',
        original: 'RAL 6008 Braungrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6009',
        original: 'RAL 6009 Tannengrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6010',
        original: 'RAL 6010 Grasgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6011',
        original: 'RAL 6011 Resedagrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6012',
        original: 'RAL 6012 Schwarzgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6013',
        original: 'RAL 6013 Schilfgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6014',
        original: 'RAL 6014 Gelboliv',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6015',
        original: 'RAL 6015 Schwarzoliv',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6016',
        original: 'RAL 6016 Türkisgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6017',
        original: 'RAL 6017 Maigrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6018',
        original: 'RAL 6018 Gelbgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6019',
        original: 'RAL 6019 Weißgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6020',
        original: 'RAL 6020 Chromoxidgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6021',
        original: 'RAL 6021 Blaßgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6022',
        original: 'RAL 6022 Braunoliv',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6024',
        original: 'RAL 6024 Verkehrsgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6025',
        original: 'RAL 6025 Farngrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6026',
        original: 'RAL 6026 Opalgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6027',
        original: 'RAL 6027 Lichtgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6028',
        original: 'RAL 6028 Kieferngrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6029',
        original: 'RAL 6029 Minzgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6032',
        original: 'RAL 6032 Signalgrün',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6033',
        original: 'RAL 6033 Minttürkis',
        value: 'LLT130011'
    },
    {
        name: 'RAL 6034',
        original: 'RAL 6034 Pastelltürkis',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7000',
        original: 'RAL 7000 Fehgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7001',
        original: 'RAL 7001 Silbergrau',
        value: 'LLT130002'
    },
    {
        name: 'RAL 7002',
        original: 'RAL 7002 Olivgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7003',
        original: 'RAL 7003 Moosgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7004',
        original: 'RAL 7004 Signalgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7005',
        original: 'RAL 7005 Mausgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7006',
        original: 'RAL 7006 Beigegrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7008',
        original: 'RAL 7008 Khakigrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7009',
        original: 'RAL 7009 Grüngrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7010',
        original: 'RAL 7010 Zeltgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7011',
        original: 'RAL 7011 Eisengrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7012',
        original: 'RAL 7012 Basaltgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7013',
        original: 'RAL 7013 Braungrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7015',
        original: 'RAL 7015 Schieferngrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7016',
        original: 'RAL 7016 Anthrazitgrau',
        value: 'LLT130003'
    },
    {
        name: 'RAL 7021',
        original: 'RAL 7021 Schwarzgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7022',
        original: 'RAL 7022 Umbragrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7023',
        original: 'RAL 7023 Betongrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7024',
        original: 'RAL 7024 Graphitgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7026',
        original: 'RAL 7026 Granitgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7030',
        original: 'RAL 7030 Steingrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7031',
        original: 'RAL 7031 Blaugrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7032',
        original: 'RAL 7032 Kieselgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7033',
        original: 'RAL 7033 Zementgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7034',
        original: 'RAL 7034 Gelbgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7035',
        original: 'RAL 7035 Lichtgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7036',
        original: 'RAL 7036 Platingrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7037',
        original: 'RAL 7037 Staubgrau',
        value: 'LLT130004'
    },
    {
        name: 'RAL 7038',
        original: 'RAL 7038 Achatgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7039',
        original: 'RAL 7039 Quarzgrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7040',
        original: 'RAL 7040 Fenstergrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7042',
        original: 'RAL 7042 Verkehrsgr. A',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7043',
        original: 'RAL 7043 Verkehrsgr. B',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7044',
        original: 'RAL 7044 Seidengrau',
        value: 'LLT130011'
    },
    {
        name: 'RAL 7047',
        original: 'RAL 7047 Telegrau',
        value: 'LLT130005'
    },
    {
        name: 'RAL 8000',
        original: 'RAL 8000 Grünbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8001',
        original: 'RAL 8001 Ockerbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8002',
        original: 'RAL 8002 Signalbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8003',
        original: 'RAL 8003 Lehmbraun',
        value: 'LLT130006'
    },
    {
        name: 'RAL 8004',
        original: 'RAL 8004 Kupferbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8007',
        original: 'RAL 8007 Rehbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8008',
        original: 'RAL 8008 Olivbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8011',
        original: 'RAL 8011 Nußbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8012',
        original: 'RAL 8012 Rotbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8014',
        original: 'RAL 8014 Sepiabraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8015',
        original: 'RAL 8015 Kastanienbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8016',
        original: 'RAL 8016 Mahagonibraun',
        value: 'LLT130007'
    },
    {
        name: 'RAL 8017',
        original: 'RAL 8017 Schokoladenbr.',
        value: 'LLT130008'
    },
    {
        name: 'RAL 8019',
        original: 'RAL 8019 Graubraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8022',
        original: 'RAL 8022 Schwarzbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8023',
        original: 'RAL 8023 Orangenbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8024',
        original: 'RAL 8024 Beigebraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8025',
        original: 'RAL 8025 Blaßbraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 8028',
        original: 'RAL 8028 Terrabraun',
        value: 'LLT130011'
    },
    {
        name: 'RAL 9001',
        original: 'RAL 9001 Cremeweiß',
        value: 'LLT130011'
    },
    {
        name: 'RAL 9002',
        original: 'RAL 9002 Grauweiß',
        value: 'LLT130011'
    },
    {
        name: 'RAL 9003',
        original: 'RAL 9003 Signalweiß',
        value: 'LLT130011'
    },
    {
        name: 'RAL 9004',
        original: 'RAL 9004 Signalschwarz',
        value: 'LLT130011'
    },
    {
        name: 'RAL 9005',
        original: 'RAL 9005 Tiefschwarz',
        value: 'LLT130011'
    },
    {
        name: 'RAL 9007',
        original: 'RAL 9007 Graualuminium',
        value: 'LLT130020'
    },
    {
        name: 'RAL 9010',
        original: 'RAL 9010 Reinweiß',
        value: 'LLT130009'
    },
    {
        name: 'RAL 9011',
        original: 'RAL 9011 Graphitschwarz',
        value: 'LLT130011'
    },
    {
        name: 'RAL 9016',
        original: 'RAL 9016 Verkehrsweiß',
        value: 'LLT130010'
    },
    {
        name: 'RAL 9017',
        original: 'RAL 9017 Verkehrsschwarz',
        value: 'LLT130011'
    },
    {
        name: 'RAL 9018',
        original: 'RAL 9018 Papyrusweiß',
        value: 'LLT130011'
    },
    {
        name: 'RAL Sonder',
        original: 'RAL (Sonder)',
        value: 'LLT130011'
    }
]

export default function bestCopyEver(src: any) {
    return Object.assign({}, src);
}
